export default {
    headbar: {
        // 顶部按钮
        file: '文件',
        mode: '模式',
        layout: '布局',
        manualLayout: '手动排版',
        fingeringAnnotation: '指法标注',

        // 文件菜单
        fileMenu: {
            importTxt: '导入 (.txt)',
            exportSvg: '导出 (.svg)',
            exportPdf: '导出 (.pdf)',
            exportTxt: '导出 (.txt)'
        },

        // 模式选项
        modeOptions: {
            'piano-roll': '卷帘谱',
            'guitar-tablature': '七线谱'
        },

        // 设置对话框
        settings: {
            title: '谱面设置',
            tabs: {
                page: '页面设置',
                font: '字体设置',
                roll: '琴卷设置',
                lines: '七线设置',
                lyrics: '歌词设置',
                finger: '指法设置'
            },
            page: {
                paperAndMargin: '页面与边距',
                paperSize: '纸张尺寸',
                selectPaper: '选择纸张',
                marginSettings: '边距设置',
                margins: {
                    top: '上',
                    right: '右',
                    bottom: '下',
                    left: '左'
                },
                spacingSettings: '间距设置',
                topSpacing: '谱子上间距',
                lyricsSpacing: '歌词上间距',
                fingeringSpacing: '指法上间距'
            },
            common: {
                font: '字体',
                size: '字号',
                color: '颜色',
                style: '样式',
                bold: '粗体',
                italic: '斜体',
                align: '对齐方式'
            },
            font: {
                titleStyle: '标题样式',
                keyStyle: '调号样式',
                options: {
                    default: '默认',
                    songti: '宋体',
                    heiti: '黑体',
                    kaiti: '楷体',
                    fangsong: '仿宋',
                    yuanti: '圆体',
                    xingkai: '行楷',
                    calligraphy: '书法体'
                }
            },
            roll: {
                basic: '基本设置',
                appearance: '外观设置',
                rollHeight: '卷帘高度',
                beatsPerLine: '每行拍数',
                rollColor1: '卷帘颜色1',
                rollColor2: '卷帘颜色2',
                noteStroke: '音符描边颜色',
                noteFill: '音符填充颜色',
                triangleStroke: '三角描边颜色',
                triangleFill: '三角填充颜色',
                positionColor: '徽位颜色',
                positionFont: '徽位字体',
                noteCorner: '音符边角',
                cornerRounded: '圆角',
                cornerSquare: '方角'
            },
            lines: {
                basic: '基本设置',
                appearance: '外观设置',
                lineSpacing: '线间间距',
                notesPerLine: '每行音符',
                thickLine: '粗线条颜色',
                thinLine: '细线条颜色',
                triangleStroke: '三角描边颜色',
                triangleFill: '三角填充颜色',
                positionColor: '徽位颜色',
                positionFont: '徽位字体'
            },
            lyrics: {
                style: '歌词样式'
            },
            finger: {
                style: '指法样式'
            },
            cancel: '取消',
            save: '保存设置',
            size: {
                small: '小',
                medium: '中',
                large: '大'
            },
            align: {
                left: '左对齐',
                center: '居中',
                right: '右对齐'
            },

            reset: '一键恢复',
            resetTitle: '确认恢复',
            resetConfirm: '确定要将所有设置恢复到默认值吗？',
            resetConfirmButton: '确定恢复',
            resetCancelButton: '取消',
            resetSuccess: '已恢复默认设置'
        },

        help: {
            title: '减字谱输入规范',
            structure: '1. 输入区域结构',
            inputRules: '2. 减字输入规则',
            rhythmSymbols: '3. 节奏符号',
            lyricsRules: '4. 歌词输入规范',
            layoutModes: '5. 排版模式',
            close: '关闭'
        },

        jianpuConverter: {
            title: '简谱转换',
            jianpuInput: '简谱输入',
            jianpuPlaceholder: '请输入简谱数字（如：1 2, 3\' 4,, 5\'\' 6 7）',
            cancel: '取消',
            convert: '转换'
        }
    },
    tablature: {
        key: '定调',
        stringNo: '弦号'
    }
}